import React from 'react'
import { MessageContainer } from './styles'

export interface AlertMessageProps {
  children: string
}

export const AlertMessage = ({ children }: AlertMessageProps): JSX.Element => {
  return <MessageContainer>{children}</MessageContainer>
}
